import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { useCallback, useState } from 'react';

import RegisterLinkOrPriceExperiment from '@/components/GridItemCard/Card/CardOptions/TimedPlusItemCard/components/RegisterLinkOrPrice/RegisterLinkOrPriceExperiment';
import ItemCardPriceRowExperiment from '@/components/GridItemCard/Card/components/ItemCardPriceRow/ItemCardPriceRowExperiment';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryBidCount,
    getItemSummaryIsBuyNowOnly,
    getItemSummaryIsTimedPlusAuction,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { ItemSummary } from '@/types/item/ItemSummary';
import { ItemCardNavigationTrigger, useTrackRegisterForAuctionPressedAnalytics } from '@/utils/amplitude/analytics';
import { useItemCardNavigation } from '@/utils/amplitude/experiments/hooks/useItemCardNavigation';

export type PriceComponentSearchCardProps = ItemSummary & { position: number };

export const PriceComponentSearchCard = createInfo<PriceComponentSearchCardProps>({
    useText: ({ itemId, position, promoted }) => {
        const bidCount = useAppSelector((state) => getItemSummaryBidCount(state, itemId));
        const isTimedPlusAuction = useAppSelector((state) => getItemSummaryIsTimedPlusAuction(state, itemId));
        const isBuyNowOnly = useAppSelector((state) => getItemSummaryIsBuyNowOnly(state, itemId));

        const [linkHover, setLinkHover] = useState(false);
        const { onNavigateInitiated } = useItemCardNavigation(itemId);
        const trackRegisterForAuctionPressedAnalytics = useTrackRegisterForAuctionPressedAnalytics();

        const enterLinkHoverState = useCallback(() => {
            setLinkHover(true);
        }, []);

        const leaveLinkHoverState = useCallback(() => {
            setLinkHover(false);
        }, []);

        return (
            <div className="relative mb-xs flex items-center justify-between px-xs smMin:mb-sm smMin:px-sm">
                {isTimedPlusAuction && !isBuyNowOnly ? (
                    <RegisterLinkOrPriceExperiment
                        itemId={itemId}
                        linkHover={linkHover}
                        onNavigate={() => {
                            onNavigateInitiated(ItemCardNavigationTrigger.PriceClick, { position, promoted });
                        }}
                        onRegisterForAuctionClicked={() => trackRegisterForAuctionPressedAnalytics()}
                    />
                ) : (
                    <ItemCardPriceRowExperiment
                        isHovered={linkHover}
                        itemId={itemId}
                        onMouseEnter={enterLinkHoverState}
                        onMouseLeave={leaveLinkHoverState}
                        onNavigate={() => {
                            onNavigateInitiated(ItemCardNavigationTrigger.PriceClick, { position, promoted });
                        }}
                        showBidCount={Boolean(bidCount)}
                    />
                )}
            </div>
        );
    },
});
